/* ==========================================================================
Libraries
========================================================================== */
global.$ = global.jQuery = require('jquery');
import Swiper from 'swiper/swiper-bundle.min';
import { Loader } from '@googlemaps/js-api-loader';
require('@fancyapps/fancybox');
require('bootstrap');

/* ==========================================================================
WCM Libraries
========================================================================== */
require("@wallbrinkcrossmedia/wcm-ts-on-scroll");
require('@wallbrinkcrossmedia/wcm-es6-scroll-tracker');

/* ==========================================================================
Sub classes
========================================================================== */
require('./_filters');

/* ==========================================================================
Theme Functions
========================================================================== */
import SmoothAnchorScroller from './_scroll_to';
import ImageViewer from "./classes/image-viewer";
import MakeProductSlider from './functions/MakeProductSlider';
import OverlayManager from './classes/OverlayManager';

global.googleMapsLoader = Loader;

$(document).ready(function () {

    // Enable Tooltips used by product cateogires
    $('[data-toggle="tooltip"]').tooltip()

    /**
     * Registers serval overlays tailormade for Sleegers Technique
     * @type {OverlayManager}
     */
    const overlayManager = new OverlayManager();

    /**
     * Menu
     * @type {*|jQuery|HTMLElement}
     */
    const menu = $('#desktop-navigation-bar');

    /**
     * Takes care of making the navigation sticky
     * @type {OnScroll}
     */
    const OnScroll = new window.OnScroll();
    OnScroll.on('scrolledMoreThan', () => {
        if(!menu.hasClass('navigation-bar--sticky')) {
            menu.addClass('navigation-bar--sticky');
        }
    }, () => {
        if(menu.hasClass('navigation-bar--sticky')) {
            menu.removeClass('navigation-bar--sticky');
        }
    }, {
        threshold: 300
    })

    /**
     * Mobile Navigation
     * @type {*|jQuery|HTMLElement}
     */
    const mobileNavigation = $('#js-mobile-navigation')

    /**
     * Mobile Navigation bar sticked at the bottom of the screen
     * @type {*|jQuery|HTMLElement}
     */
    const mobileNavigationBar = $('#js-mobile-navigation-bar')

    /**
     * Mobile menu button
     * @type {*|jQuery|HTMLElement}
     */
    const mobileMenuButton = $('#js-mobile-menu-toggle')
    mobileMenuButton.on('click', () => {
        let hamburger = $('.hamburger')
        hamburger.toggleClass('is-active')
        mobileNavigation.toggleClass('site-menu--active')
        mobileNavigationBar.find('.navigation-bar__container--home').toggleClass('navigation-bar__container--home-active');
        mobileNavigationBar.find('.navigation-bar__container--logo').toggleClass('navigation-bar__container--logo-inactive')
    })

    /**
     * Takes care of the sub-items in the mobile menu
     * @type {*|jQuery|HTMLElement}
     */
    const mobileMenuToggles = $('#js-mobile-navigation .js-static-menu-dropdown-toggle');
    mobileMenuToggles.on('click', (el) => {
        let toggle = $(el.currentTarget);
        toggle.toggleClass('mobile-navigation-menu-dropdown-toggle--active');
        let subMenu = toggle.parent().find('ul').first();
        subMenu.slideToggle();
    })

    /**
     * Scroll Tracker instance
     * @type {ScrollTracker}
     */
    const scrollTracker = new ScrollTracker('js-scroll-tracker', {
        background: '#377acf',
        height: '5px'
    })

    /**
     * Product slider instance
     * @type {Swiper}
     */
    const productSlider = MakeProductSlider();

    /**
     * Smooth Scroller for Arrows
     * @type {SmoothAnchorScroller}
     */
    let arrowScroller = new SmoothAnchorScroller('.js-page-scroll', {
        speed: 800,
        offset: 30,
    });

    /**
     * Agenda slider
     */
    var agendaSwiper = new Swiper('#agenda-home .swiper-container', {
        slidesPerView: 'auto',
        direction: 'horizontal',
        centeredSlides: true,
        spaceBetween: 20,
        loop: false,
        navigation: {
            nextEl: '#agenda-home .js-swiper-button-next',
            prevEl: '#agenda-home .js-swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                centeredSlides: false,
            },
            992: {
                slidesPerView: 3,
                centeredSlides: false,
            },
            1200: {
                slidesPerView: 2,
                centeredSlides: false,
                spaceBetween: 30
            },
            1600: {
                slidesPerView: 2,
                centeredSlides: false,
                spaceBetween: 40
            },
            1700: {
                slidesPerView: 3,
                centeredSlides: false,
                spaceBetween: 40
            }
        },
    });

    window.initTeamMembersSwiper = function () {
        window.teamMemberSwiper = new Swiper('#team-members .swiper-container', {
            effect: 'slide',
            slidesPerView: 1,
            navigation: {
                nextEl: '#team-members .js-swiper-button-next',
                prevEl: '#team-members .js-swiper-button-prev',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 100
                }
            }
        });
    }
    window.initTeamMembersSwiper();


    /**
     * Product-detail swiper
     */
    $('.bottom-slider .swiper-slide').click(function (e) {
        var index = $(this).data('index');
        $('.bottom-slider .swiper-slide.active').removeClass('active');
        $(this).addClass('active');
        productDetailSwiper.slideTo(index);
    });


    var productDetailSwiper = new Swiper('#product-detail #top-slider .swiper-container', {
        effect: 'slide',
        noSwiping: true,
        slidesPerView: 1,
        simulateTouch: false,
        spaceBetween: 30,
        navigation: {
            nextEl: '#product-detail #top-slider .swiper-button-next',
            prevEl: '#product-detail #top-slider .swiper-button-prev',
        },
        breakpoints: {
            // when window width is <= 1200px
            1200: {
                noSwiping: true,
                simulateTouch: false,
                spaceBetween: 30.
            }
        }
    });

    var productDetailBottomSwiper = new Swiper('#product-detail .bottom-slider .swiper-container', {
        effect: 'slide',
        slidesPerView: 'auto',
        slidesPerColumn: 2,
        slidesPerGroup: 3,
        direction: 'horizontal',
        centeredSlides: false,
        navigation: {
            nextEl: '#product-detail .bottom-slider .swiper-button-next',
            prevEl: '#product-detail .bottom-slider .swiper-button-prev',
        },
        breakpoints: {
            // when window width is <= 992px
            992: {
                centeredSlides: true,
                loop: false,
                slidesPerGroup: 1,
                slidesPerView: 'auto',
                slidesPerColumn: 0,
                direction: 'horizontal'
            }
        }
    });

    /***
     * Hide menu/popup
     */
    $('.js-m-popup-close').click(function (e) {
        $('#searchmenu').removeClass('active');
        $('#desktop-menu').removeClass('active');
        $('#breadcrumb-popup').removeClass('active');
        $('#share-popup').removeClass('active');
    });

    /***
     * Show Searchmenu
     */
    $('.show-searchmenu').click(function (e) {
        e.preventDefault();
        $('#searchmenu').toggleClass('active');
    });

    /***
     * Select moduleitem
     */
    $('.module-item').click(function (e) {
        e.preventDefault();
        $(this).toggleClass('checked');
    });

    $("#selectors > select").on("change", function () {
        $(this).addClass('selected');
    });

    /***
     * View video
     */
    $('.open-video').click(function (e) {
        e.preventDefault();
        $(this).toggleClass('open');
    });

    $('.close-video').click(function (e) {
        e.preventDefault();
        $('.open-video').parents().removeClass('open');
    });

    const productImageViewer = new ImageViewer({
        classes: {
            thumbnailActive: 'sleegers-image-viewer-thumbnail--active'
        },

        events: {
            onActiveThumbnailChanged(activeThumbnail, imageSource) {
                $('.js-image-viewer-view-fancybox').attr('href', imageSource);
            }
        }
    });


});
